import React from 'react'
import "./MySkills.css"
import Card from 'react-bootstrap/Card'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'

import {
    SiNextdotjs, SiExpress, SiJavascript, SiTypescript, SiGithub, SiSass, SiCss3, SiHtml5,
    SiBootstrap, SiTailwindcss, SiHeroku, SiFirebase, SiNetlify,
}
    from 'react-icons/si'

import { faEnvira, faReact, faNodeJs, } from '@fortawesome/free-brands-svg-icons'



import AOS from 'aos'
import 'aos/dist/aos.css' // You can also use <link> for styles
// ..
AOS.init()



const MySkills = () => {

    return (
        <div>
            <h2 className='text-center py-5 react_icon'>MY SKILLS</h2>

            <div className='row m-0 p-0 gy-3'>

                {/* React */}

                <div className='col-lg-3 '


                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="900"
                >
                    <Card className='main-card navimg red-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-2'>React JS</Card.Title>

                            <div className="react_icon">
                                <FontAwesomeIcon icon="react" />
                                <FontAwesomeIcon icon={['fas', 'react']} />
                                <FontAwesomeIcon icon={['far', 'react']} />
                                <FontAwesomeIcon icon={faReact} />
                            </div>

                        </Card.Body>
                    </Card>
                </div>

                {/* Next js */}

                <div className='col-lg-3 '

                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1100"
                >
                    <Card className='main-card navimg blue-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Next JS

                            </Card.Title>

                            <div className="react_icon">
                                <SiNextdotjs ></SiNextdotjs>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* Express js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1500"
                >
                    <Card className='main-card navimg white-border ' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Express JS

                            </Card.Title>

                            <div className="react_icon">
                                <SiExpress ></SiExpress>
                            </div>


                        </Card.Body>
                    </Card>
                </div>


                {/* Node js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="2000"
                >
                    <Card className='main-card navimg sky-border ' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-2'>Node JS</Card.Title>

                            <div className="react_icon">
                                <FontAwesomeIcon icon="nodejs" />
                                <FontAwesomeIcon icon={['fas', 'nodejs']} />
                                <FontAwesomeIcon icon={['far', 'nodejs']} />
                                <FontAwesomeIcon icon={faNodeJs} />
                            </div>

                        </Card.Body>
                    </Card>
                </div>
                {/* MOngoDb */}
                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="900"
                >
                    <Card className='main-card navimg green-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-2'>MongoDb</Card.Title>

                            <div className="react_icon">
                                <FontAwesomeIcon icon="envire" />
                                <FontAwesomeIcon icon={['far', 'envire']} />
                                <FontAwesomeIcon icon={['fas', 'envire']} />
                                <FontAwesomeIcon icon={faEnvira} />
                            </div>

                        </Card.Body>
                    </Card>
                </div>

                {/* Javascrpt js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1100"
                >
                    <Card className='main-card navimg pink-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Javascript

                            </Card.Title>

                            <div className="react_icon">
                                <SiJavascript ></SiJavascript>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* Typescript js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1500"
                >
                    <Card className='main-card navimg lightBlue-border ' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Typescript

                            </Card.Title>

                            <div className="react_icon">
                                <SiTypescript ></SiTypescript>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* SiTailwindcss js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="2000"
                >
                    <Card className='main-card navimg velo-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Tailwind Css

                            </Card.Title>

                            <div className="react_icon">
                                <SiTailwindcss ></SiTailwindcss>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* SiBootstrap js */}

                <div className='col-lg-3'

                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="900"
                >
                    <Card className='main-card navimg vel-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Bootstrap

                            </Card.Title>

                            <div className="react_icon">
                                <SiBootstrap ></SiBootstrap>
                            </div>


                        </Card.Body>
                    </Card>
                </div>
                {/* SiBootstrap js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1100"
                >
                    <Card className='main-card navimg soro-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Firebase

                            </Card.Title>

                            <div className="react_icon">
                                <SiFirebase ></SiFirebase>
                                {/* <IoLogoFirebase ></IoLogoFirebase> */}
                            </div>


                        </Card.Body>
                    </Card>
                </div>


                {/* SiHeroku js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1500"
                >
                    <Card className='main-card navimg sor-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Heroku

                            </Card.Title>

                            <div className="react_icon">
                                <SiHeroku ></SiHeroku>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* SiHeroku js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="2000"
                >
                    <Card className='main-card navimg yegre-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Netlify

                            </Card.Title>

                            <div className="react_icon">
                                <SiNetlify ></SiNetlify>
                            </div>


                        </Card.Body>
                    </Card>
                </div>
                {/* SiGithub js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="900"
                >
                    <Card className='main-card navimg var-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Github

                            </Card.Title>

                            <div className="react_icon">
                                <SiGithub ></SiGithub>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* SiSass js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1100"
                >
                    <Card className='main-card navimg or-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Sass

                            </Card.Title>

                            <div className="react_icon">
                                <SiSass ></SiSass>
                            </div>


                        </Card.Body>
                    </Card>
                </div>

                {/* Css js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="1500"
                >
                    <Card className='main-card navimg ele-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Css 3

                            </Card.Title>

                            <div className="react_icon">
                                <SiCss3 ></SiCss3>
                            </div>


                        </Card.Body>
                    </Card>
                </div>
                {/* Css js */}

                <div className='col-lg-3'
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-bottom"
                    data-aos-duration="2000"
                >
                    <Card className='main-card navimg twe-border' style={{ width: '18rem' }}>
                        <Card.Body className='d-flex justify-content-center align-items-center'>
                            <Card.Title className='text-white mx-3 mt-3'>Html 5

                            </Card.Title>

                            <div className="react_icon">
                                <SiHtml5 ></SiHtml5>
                            </div>


                        </Card.Body>
                    </Card>
                </div>







            </div>
        </div>
    )
}

export default MySkills